<div class="design-thumbnail-wrapper" (click)="openDesignPatternPreviewDialog($event)" [class.cursor-zoom-in]="canZoomInOnDesign()">
  <div class="design-frame" fxLayoutAlign="start center">
    <app-drawing-library-image-preview [drawingImage]="drawing.image" [hasMissingDesign]="drawing.missingDesign" [shouldDownloadImage]="isDrawingTypeBmp()" (imageDownloaded)="imageDownloaded($event)">
    </app-drawing-library-image-preview>
  </div>
</div>
